<script>
import metaDataJson from '@/data/json/common/metaData/metaData.json'

export default {
  props: {
    metaData: {
      type: Object
    },
    small: { type: Boolean }
  },
  data: vm => ({
    items: [],
    metaDataSourceMap: {
      [vm.$enums.MetaDataSource.Website]: vm.$t('global.website'),
      [vm.$enums.MetaDataSource.MetaTag]: vm.$t('global.tag'),
      [vm.$enums.MetaDataSource.WhiteLine]: vm.$t('component.profile.printParameters.white.line')
    },
    toolTips: {
      fileSize: vm.$cms.get(metaDataJson, 'tip_file_size'),
      printMode: vm.$t('component.profile.printParameters.page.settings'),
      colorMode: vm.$t('component.profile.printParameters.color.settings'),
      foldType: vm.$t('component.profile.printParameters.fold.type'),
      letterType: vm.$t('component.profile.printParameters.tip.letter.type'),
      paperType: vm.$t('component.profile.printParameters.tip.paper.type'),
      split: vm.$t('component.profile.printParameters.tip.split'),
      costCenter: vm.$t('component.profile.printParameters.tip.cost.center')
    }
  }),
  created() {
    this.init()
  },
  methods: {
    add({
      text = null,
      value = null,
      raw = false,
      locked = false,
      tip = null,
      contentPrefix = null
    }) {
      let isObject = typeof text === 'object'

      if (text && isObject) {
        if (text.length > 1) {
          text = text.map(textElement =>
            this.$t(contentPrefix + textElement)
          )
        } else {
          isObject = false
          raw = true
          text = this.$t(contentPrefix + text[0])
        }
      }
      text &&
        this.items.push({
          text: raw ? text : this.$t(text),
          value: value,
          locked: locked,
          tip: tip,
          isObject: isObject
        })
    },
    init() {
      // normalize:
      // lower-case first letters because object-keys are not equal (it's a mix of pascal-case and camel-case)
      const normalized = Object.fromEntries(
        Object.entries(this.metaData).map(([[firstLetter, ...rest], value]) => [
          firstLetter.toLowerCase() + rest.join(''),
          value
        ])
      )

      const {
        printMode,
        colorMode,
        splitType,
        splitAfterTextPattern,
        splitAfterNPages,
        letterType,
        paperTypes,
        foldType,
        costCenter,
        metaDataInfo
      } = normalized

      const { hasFoldType, hasCostCenter } = this.$permissions

      const metaDataSource = this.metaDataSourceMap[metaDataInfo.source]
      const locked = this.$t('component.profile.printParameters.locked', {
        '${metaDataSource}': metaDataSource })
      this.add({
        text: letterType && `component.profile.printParameters.letter.${letterType}`,
        tip: [this.toolTips.letterType] })
      this.add({
        raw: true,
        contentPrefix: 'component.profile.printParameters.paper.',
        text: paperTypes,
        tip: [this.toolTips.paperType] })
      this.add({
        text: `component.profile.printParameters.print.${printMode}`,
        locked: metaDataInfo.hasPrintMode,
        tip: [this.toolTips.printMode, metaDataInfo.hasPrintMode && locked] })
      this.add({
        text: `component.profile.printParameters.color.${colorMode}`,
        locked: metaDataInfo.hasColorMode,
        tip: [this.toolTips.colorMode, metaDataInfo.hasColorMode && locked] })
      this.add({
        text: hasFoldType && `component.profile.printParameters.fold.type.${foldType}`,
        locked: metaDataInfo.hasFoldType,
        tip: [this.toolTips.foldType, metaDataInfo.hasFoldType && locked] })
      this.add({
        text: splitType && `component.profile.printParameters.split.type.${splitType}`,
        value: splitAfterTextPattern || splitAfterNPages,
        locked: metaDataInfo.hasSerialSeq,
        tip: [this.toolTips.split, metaDataInfo.hasSerialSeq && locked] })
      this.add({
        text: hasCostCenter && costCenter,
        raw: true,
        locked: metaDataInfo.hasCostCenter,
        tip: [this.toolTips.costCenter, metaDataInfo.hasCostCenter && locked] })
    }
  }
}
</script>
<template>
  <v-row no-gutters>
    <v-col v-for="(item, index) in items" :key="index" cols="auto">
      <v-tooltip :disabled="!item.tip" top>
        <template #activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            class="mr-1 mb-1 pr-2 pl-2"
            label
            :small="small"
            v-on="on" >
            <span v-if="item.isObject">
              <v-chip
                v-for="(itemText, itemTextIndex) in item.text"
                :key="itemTextIndex"
                label
                small
                class="grey lighten-3 my-1"
                :class="{ 'ml-1': itemTextIndex > 0, unsetHeight: small }"
              >{{ itemText }}</v-chip  >
            </span>
            <span v-else>
              {{ item.text }}
              <span v-if="item.value" class="primary--text">
                {{ item.value }}
              </span>
              <v-icon
                v-if="item.locked"
                color="primary"
                class="ml-1"
                right
                small >
                mdi-lock
              </v-icon>
            </span>
          </v-chip></template>
        <div v-for="(tip, tipIndex) in item.tip" :key="tipIndex">
          <span v-if="tip">{{ tip }}</span>
        </div>
      </v-tooltip>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
.unsetHeight {
  height: unset !important;
}
</style>
